(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pure-ground-vanilla-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeHero = (hero) => {
      if (hero.dataset.initialized === 'true') return;
      hero.dataset.initialized = 'true';

      const items = Array.from(hero.querySelectorAll('[data-pgv-use-case]'));
      const clones = Array.from(hero.querySelectorAll('[data-pgv-use-case-clone]'));
      const track = hero.querySelector('[data-pgv-use-cases-track]');
      if (items.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      let activeIndex = 0;
      const speed = Number.parseInt(hero.dataset.cycleSpeed, 10) || 1500;

      window.setInterval(() => {
        items[activeIndex].classList.remove('is-active');
        activeIndex += 1;

        if (activeIndex === items.length) {
          clones[0].classList.add('is-active');
          track.style.setProperty('--pgv-use-case-index', activeIndex);

          window.setTimeout(() => {
            track.classList.add('is-resetting');
            clones[0].classList.remove('is-active');
            activeIndex = 0;
            items[activeIndex].classList.add('is-active');
            track.style.setProperty('--pgv-use-case-index', activeIndex);

            requestAnimationFrame(() => {
              requestAnimationFrame(() => track.classList.remove('is-resetting'));
            });
          }, 870);

          return;
        }

        items[activeIndex].classList.add('is-active');
        track.style.setProperty('--pgv-use-case-index', activeIndex);
      }, speed);
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-pgv-hero]').forEach(initializeHero);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pure-ground-vanilla-press"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializePressCarousel = (section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      const items = Array.from(section.querySelectorAll('[data-pgv-press-item]'));
      const quotes = Array.from(section.querySelectorAll('[data-pgv-press-quote]'));
      const toggle = section.querySelector('[data-pgv-press-toggle]');
      const previous = section.querySelector('[data-pgv-press-previous]');
      const next = section.querySelector('[data-pgv-press-next]');
      const autoplay = section.dataset.autoplay === 'true';
      const interval = Number.parseInt(section.dataset.interval, 10) || 5000;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let activeIndex = 0;
      let timer;
      let userPaused = reducedMotion.matches || !autoplay;

      const paint = () => {
        const midpoint = Math.floor(items.length / 2);

        items.forEach((item, index) => {
          let position = index - activeIndex;
          if (position > midpoint) position -= items.length;
          if (position < -midpoint) position += items.length;

          item.dataset.position = position;
          item.dataset.opposite = items.length % 2 === 0 && position === midpoint ? 'true' : 'false';
          item.setAttribute('aria-hidden', position === 0 ? 'false' : 'true');
        });

        quotes.forEach((quote, index) => {
          const isActive = index === activeIndex;
          quote.classList.toggle('is-active', isActive);
          quote.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });
      };

      const stop = () => {
        window.clearInterval(timer);
        timer = undefined;
      };

      const start = () => {
        stop();
        if (userPaused || items.length < 2) return;
        timer = window.setInterval(() => {
          activeIndex = (activeIndex + 1) % items.length;
          paint();
        }, interval);
      };

      const updateControls = () => {
        section.classList.toggle('is-paused', userPaused);
        if (!toggle) return;
        toggle.classList.toggle('is-paused', userPaused);
        toggle.setAttribute('aria-label', userPaused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
        toggle.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
      };

      const navigate = (direction) => {
        userPaused = true;
        activeIndex = (activeIndex + direction + items.length) % items.length;
        paint();
        updateControls();
        start();
      };

      if (toggle) {
        toggle.addEventListener('click', () => {
          userPaused = reducedMotion.matches ? true : !userPaused;
          updateControls();
          start();
        });
      }

      if (previous) previous.addEventListener('click', () => navigate(-1));
      if (next) next.addEventListener('click', () => navigate(1));

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stop();
        else start();
      });

      reducedMotion.addEventListener('change', (event) => {
        userPaused = event.matches || !autoplay;
        updateControls();
        start();
      });

      paint();
      updateControls();
      start();
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-pgv-press]').forEach(initializePressCarousel);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pure-ground-vanilla-recipes"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeRecipes = (section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      const viewport = section.querySelector('[data-pgv-recipes-viewport]');
      const track = section.querySelector('[data-pgv-recipes-track]');
      const originalCards = Array.from(section.querySelectorAll('[data-pgv-recipes-card]'));
      const previous = section.querySelector('[data-pgv-recipes-previous]');
      const next = section.querySelector('[data-pgv-recipes-next]');
      if (!viewport || !track || originalCards.length === 0) return;

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const originalCount = originalCards.length;
      let cards = originalCards;
      let activeIndex = 0;
      let scrollFrame;
      let settleTimer;
      let isJumping = false;

      const cardScrollLeft = (card) => {
        const trackPadding = Number.parseFloat(window.getComputedStyle(track).paddingLeft) || 0;
        const viewportRect = viewport.getBoundingClientRect();
        const cardRect = card.getBoundingClientRect();
        return Math.max(0, viewport.scrollLeft + cardRect.left - viewportRect.left - trackPadding);
      };

      const paint = () => {
        cards.forEach((card, index) => {
          card.classList.toggle('is-active', index === activeIndex);
        });
      };

      if (originalCount === 1) {
        paint();
        return;
      }

      const cloneCard = (card) => {
        const clone = card.cloneNode(true);
        clone.classList.remove('is-active');
        clone.setAttribute('data-pgv-recipes-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('data-shopify-editor-block');
        clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
        clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => {
          element.setAttribute('tabindex', '-1');
        });
        return clone;
      };

      const beforeFragment = document.createDocumentFragment();
      const afterFragment = document.createDocumentFragment();
      originalCards.forEach((card) => {
        beforeFragment.appendChild(cloneCard(card));
        afterFragment.appendChild(cloneCard(card));
      });
      track.prepend(beforeFragment);
      track.append(afterFragment);

      cards = Array.from(track.querySelectorAll('[data-pgv-recipes-card]'));
      activeIndex = originalCount;

      const moveTo = (index, behavior = 'smooth') => {
        activeIndex = Math.max(0, Math.min(index, cards.length - 1));
        paint();
        viewport.scrollTo({
          left: cardScrollLeft(cards[activeIndex]),
          behavior: reducedMotion.matches ? 'auto' : behavior
        });
      };

      const jumpTo = (index) => {
        isJumping = true;
        viewport.classList.add('is-jumping');
        activeIndex = index;
        paint();
        viewport.scrollLeft = cardScrollLeft(cards[activeIndex]);

        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            viewport.classList.remove('is-jumping');
            isJumping = false;
          });
        });
      };

      const normalizePosition = () => {
        if (activeIndex < originalCount) {
          jumpTo(activeIndex + originalCount);
        } else if (activeIndex >= originalCount * 2) {
          jumpTo(activeIndex - originalCount);
        }
      };

      const updateFromScroll = () => {
        if (isJumping) return;
        window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(() => {
          const nearestIndex = cards.reduce((nearest, card, index) => {
            const nearestDistance = Math.abs(viewport.scrollLeft - cardScrollLeft(cards[nearest]));
            const cardDistance = Math.abs(viewport.scrollLeft - cardScrollLeft(card));
            return cardDistance < nearestDistance ? index : nearest;
          }, 0);

          if (nearestIndex !== activeIndex) {
            activeIndex = nearestIndex;
            paint();
          }

          window.clearTimeout(settleTimer);
          settleTimer = window.setTimeout(normalizePosition, 140);
        });
      };

      previous?.addEventListener('click', () => moveTo(activeIndex - 1));
      next?.addEventListener('click', () => moveTo(activeIndex + 1));
      viewport.addEventListener('scroll', updateFromScroll, { passive: true });

      jumpTo(activeIndex);
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-pgv-recipes]').forEach(initializeRecipes);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pure-ground-vanilla-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeCookieEntrance = (scope = document) => {
      scope.querySelectorAll('.pgv-reviews:not([data-cookie-entrance-initialized])').forEach((section) => {
        section.setAttribute('data-cookie-entrance-initialized', '');
        section.classList.add('is-cookie-animation-ready');
        section.classList.add('is-stars-animation-ready');

        if (!('IntersectionObserver' in window)) {
          section.classList.add('is-cookie-visible');
          section.classList.add('is-stars-visible');
          return;
        }

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;

              entry.target.classList.add('is-cookie-visible');
              entry.target.classList.add('is-stars-visible');
              observer.unobserve(entry.target);
            });
          },
          {
            threshold: 0.2,
            rootMargin: '0px 0px -8% 0px',
          }
        );

        observer.observe(section);
      });
    };

    initializeCookieEntrance();

    document.addEventListener('shopify:section:load', (event) => {
      initializeCookieEntrance(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
